import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle", "label"]

  connect() {
    // Check if content is actually truncated (needs overflow)
    // Use setTimeout to ensure content is rendered
    setTimeout(() => {
      this.checkOverflow()
    }, 100)
  }

  checkOverflow() {
    if (!this.hasContentTarget || !this.hasToggleTarget) return

    const content = this.contentTarget
    // Compare scroll height to visible height
    const isTruncated = content.scrollHeight > content.clientHeight + 5

    if (!isTruncated) {
      // Content fits, remove truncation styling and hide button
      content.classList.remove("truncated")
      this.toggleTarget.style.display = "none"
    }
  }

  toggle() {
    if (!this.hasContentTarget || !this.hasToggleTarget || !this.hasLabelTarget) return

    const content = this.contentTarget
    const isExpanded = !content.classList.contains("truncated")

    if (isExpanded) {
      // Collapse
      content.classList.add("truncated")
      this.labelTarget.textContent = "Show more"
      this.toggleTarget.classList.remove("expanded")
    } else {
      // Expand
      content.classList.remove("truncated")
      this.labelTarget.textContent = "Show less"
      this.toggleTarget.classList.add("expanded")
    }
  }
}
